export type JsonRendererProps = {
  json: object | null;
};

export const JsonRenderer = ({ json }: JsonRendererProps) => {
  return <pre style={{ overflow: 'auto', margin: 0 }}>{JSON.stringify(json, null, 2)}</pre>;
};
